module.exports = __webpack_public_path__ + "static/media/2.f6124ec8.webp";